module.exports = __webpack_public_path__ + "static/seres-silk-duvet-4-b4123df388574f120e7ab925a47e8d3f.webp";